import { useState } from 'react';
import { SPIN_COST, SPIN_ANIMATION_DURATION } from '../../../constants/gameConfig';
import { getRandomSymbol, calculateWin } from '../utils/gameUtils';
import type { GameState } from '../../../types/game';

export const useSlotGame = (initialBalance: number = 1000) => {
    const [gameState, setGameState] = useState<GameState>({
        balance: initialBalance,
        slots: ['?', '?', '?'],
        isSpinning: false,
        activeBonus: null
    });

    const activateBonus = (spins: number, multiplier: number) => {
        setGameState((prev: GameState) => ({
            ...prev,
            activeBonus: {
                spinsLeft: spins,
                multiplier: multiplier
            }
        }));
    };

    const spin = () => {
        if (gameState.balance < SPIN_COST) return;

        setGameState((prev: GameState) => ({
            ...prev,
            isSpinning: true,
            balance: prev.balance - SPIN_COST
        }));

        setTimeout(() => {
            const newSlots = Array(3).fill(null).map(() => getRandomSymbol());
            const baseWin = calculateWin(newSlots);
            const finalWin = gameState.activeBonus
                ? baseWin * gameState.activeBonus.multiplier
                : baseWin;

            setGameState((prev: GameState) => {
                const newState: GameState = {
                    ...prev,
                    slots: newSlots,
                    isSpinning: false,
                    balance: prev.balance + finalWin
                };

                if (prev.activeBonus) {
                    const spinsLeft = prev.activeBonus.spinsLeft - 1;
                    if (spinsLeft <= 0) {
                        newState.activeBonus = null;
                    } else {
                        newState.activeBonus = { ...prev.activeBonus, spinsLeft };
                    }
                }

                return newState;
            });
        }, SPIN_ANIMATION_DURATION);
    };

    return {
        ...gameState,
        spin,
        activateBonus,
        setBalance: (balance: number) => setGameState((prev: GameState) => ({ ...prev, balance }))
    };
}; 